const SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  RUB: '₽',
  GBP: '£',
  JPY: '¥',
  CNY: '¥'
};

export function currencySymbol(code: string | null | undefined): string {
  if (!code) return '';
  return SYMBOLS[code.toUpperCase()] ?? '';
}

export function formatAmount(amount: number, currency: string | null | undefined): string {
  const fixed = amount.toFixed(2);
  const symbol = currencySymbol(currency);
  if (symbol) return `${symbol}${fixed}`;
  if (currency) return `${fixed} ${currency.toUpperCase()}`;
  return fixed;
}
